import { RouteConfig } from "vue-router"

/**
 * RouteConfigを定義します: [CsvAuthori]。
 */
export const CsvAuthoriRouteConfig: RouteConfig = {
  path: "/CsvAuthori",
  name: "CsvAuthori",
  component: () => import("%%/views/csvAuthori/CsvAuthori.vue"),
  meta: {
    reload: false,
    authRequired: true,
  },
}
